export const SidebarNavItem = {
  extends: 'Link',
  href: (el, s) => s.route || '/dashboard',
  textDecoration: 'none',
  flow: 'x',
  align: 'center flex-start',
  gap: 'Z',
  padding: 'Z A',
  round: 'Y',
  cursor: 'pointer',
  width: '100%',
  color: 'inkMuted',
  transition: 'all 0.15s ease',
  ':hover': { color: 'inkText', background: 'inkSurface' },
  isActive: (el, s) => {
    var path = window.location.pathname
    return path === s.route
  },
  '.isActive': { color: 'inkText', background: 'inkSurface' },
  NavIcon: { extends: 'Icon', icon: (el, s) => s.iconName, width: 'A', height: 'A' },
  NavLabel: { text: (el, s) => s.label, fontSize: 'Z', fontWeight: '500' }
}
